import { render, staticRenderFns } from "./AmazeAvatar.vue?vue&type=template&id=7e8b4887&scoped=true"
import script from "./AmazeAvatar.vue?vue&type=script&lang=js"
export * from "./AmazeAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8b4887",
  null
  
)

export default component.exports